import React, { useState, useEffect, useReducer } from 'react';
import './InstitutionInformation.css';
import { API, Endpoints } from '../api/API';
import { checkTrailingSpace } from '../js/verificationFunctions';

interface Institution {
    institutionId: string,
    name: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    zipCode: string,
    country: string,
    createdOn: string
}

const init_Institution: Institution = {
    institutionId: '',
    name: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    createdOn: ''
}

// Reducer handling all data collection on this component
function instituteInputReducer(state: any, action: any) {
    switch (action.type) {
        case "field":
            return {
                ...state,
                [action.field]: action.value,
            };
    }
}

interface InstituteProps {
    formStep: number,
    setFormStep: React.Dispatch<React.SetStateAction<number>>,
    institute: Institution,
    setInstitute: React.Dispatch<React.SetStateAction<any>>,
    translate: () => void,
    setBackgroundWIP: React.Dispatch<React.SetStateAction<boolean>>,
    other: boolean,
    setOther: React.Dispatch<React.SetStateAction<boolean>>,
    countries?: Record<string, string>,
    lang: string | null,
    token: string,
    institutionLinkAlwaysOptional: boolean,
    skipOptionalInstitutionLink: boolean,
    appFeatures: any
}

const InstitutionInformation = (props: InstituteProps) => {
    const selectedInstitute: Institution = { ...props.institute };
    const [institutes, setInstitutes] = useState<Array<Object>>([]);
    const [showSearchBox, setShowSearchBox] = useState<boolean>(false);
    const [validationNeeded, setValidationNeeded] = useState<boolean>(true);
    const [state, disp] = useReducer(instituteInputReducer, selectedInstitute);

    const dispatch = (obj: any) => {
        console.error(obj)
        if (props.other) {
            disp(obj);
        }
    }
    const [query, setQuery] = useState<string>('');
    const [requiredInfoError, setRequiredInfoError] = useState<Array<string>>([]);

    useEffect(() => {
        props.translate();
    }, [props.lang, institutes]);


    useEffect(() => {
        if(props.institutionLinkAlwaysOptional && !props.skipOptionalInstitutionLink){
            setValidationNeeded(false);
        }
        else{
            setValidationNeeded(true);
        }
    }, []);

    useEffect(() => {
        document.onclick = (e: any) => {
            if (e.target.id === 'institution-search' || e.target.id === 'institution-search-input') {
                return;
            }
            setShowSearchBox(false);
        }
    })

    useEffect(() => {
        $('.match-height').matchHeight();
    }, [institutes]);

    const searchInstitution = async (entry: string) => {
        entry = entry.trim();
        const body = { "name": entry };
        // const results = await getInstitutionsApi(body);
        const results = await API.POST(body, Endpoints.GetInstitutions, props.token);
        results.push({
            "institutionId": "other",
            "name": "Other",
            "address1": "",
            "address2": "",
            "city": "",
            "state": "",
            "country": "",
            "zipCode": "",
            "createdOn": ""
        })
        setInstitutes(results);
        if (entry.length > 0 && results.length > 0) {
            setShowSearchBox(true);
        }
    }

    const handleInput = (ins: any) => {
        console.error(ins);
        if (ins.name === "Other") {
            props.setOther(true);
            props.setInstitute({ ...init_Institution });
            ins = { ...init_Institution };
        } else {
            props.setInstitute(ins);
            props.setOther(false);
        }
        Object.entries(ins).forEach(([key, value]) => {
            if (value === null) {
                value = '';
            }

            disp({ type: "field", field: key, value: value });
        })

        const queryDisplay = ins.name ? ins.name : "Other";
        setQuery(queryDisplay);
        setShowSearchBox(false);
        setInstitutes([]);
    }

    const goNext = () => {
        if (props.other && (state.name === '' || state.address1 === '' || state.city === '' || state.state === '' || state.country === '' || state.zipCode === '')) {
            var currentErrors: Array<string> = [];
            if (state.name === '' && !currentErrors.includes("inst-name")) currentErrors = [...currentErrors, "inst-name"];
            if (state.address1 === '' && !currentErrors.includes("inst-addr")) currentErrors = [...currentErrors, "inst-addr"];
            if (state.city === '' && !currentErrors.includes("inst-city")) currentErrors = [...currentErrors, "inst-city"];
            if (state.state === '' && !currentErrors.includes("inst-state")) currentErrors = [...currentErrors, "inst-state"];
            if (state.zipCode === '' && !currentErrors.includes("inst-zip")) currentErrors = [...currentErrors, "inst-zip"];
            if (state.country === '' && !currentErrors.includes("inst-country")) currentErrors = [...currentErrors, "inst-country"];

            setRequiredInfoError([...currentErrors]);
            return;
        }

        setRequiredInfoError([]);

        if (props.other) {
            // set institute information to other's information
            var newInstitute: Institution = {
                "institutionId": "",
                "name": state.name,
                "address1": state.address1,
                "address2": state.address2,
                "city": state.city,
                "state": state.state,
                "country": state.country,
                "zipCode": state.zipCode,
                "createdOn": ""
            }
            props.setInstitute(newInstitute);
        }
        props.setFormStep(props.formStep + 1);
    }

    const goBack = () => {
        // Move back to Basic Information Page
        props.setFormStep(props.formStep - 1);
    }

function InstitutionValidationErrors(){

    if(props.institutionLinkAlwaysOptional && !props.skipOptionalInstitutionLink){
        //setValidationNeeded(false);
        return <></>
    }
    else{
        if(requiredInfoError.length === 0){
            //setValidationNeeded(true);
            return (
                <p className="error">
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <span className="6b53affa-993c-4cb5-ae6a-6a2761f710e7">Please provide the details of your institution.</span>
                </p>
            )
        }else{
            //setValidationNeeded(true);
            return (
            <p className="error">
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                <><span className="664eebfb-9b9d-488f-9778-2f09ffa5f99b">Please provide your</span> {requiredInfoError.map((value, index) => { return index === 0 ? $(`#${value}`).attr('placeholder') : ', ' + $(`#${value}`).attr('placeholder'); })}</>
            </p>
            )
        }
    }
}


    return (
        <div id="institution-information">
            <form className="institute-form">
                <>
                {InstitutionValidationErrors()}
                    {/* <p className="error">
                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                        {requiredInfoError.length === 0 ? <span className="6b53affa-993c-4cb5-ae6a-6a2761f710e7">Please provide the details of your institution.</span> :
                            <><span className="664eebfb-9b9d-488f-9778-2f09ffa5f99b">Please provide your</span> {requiredInfoError.map((value, index) => { return index === 0 ? $(`#${value}`).attr('placeholder') : ', ' + $(`#${value}`).attr('placeholder'); })}</>} 
                            
                    </p> */}
                    <div className="row">
                        
                            <div className="col-sm-12">
                                <p>
                                    <label className="2aa5a868-b597-4401-80ac-1b1d03cb06c9">Start typing the name of your institute...</label>
                                    <input
                                        name="institute-search"
                                        id="institution-search-input"
                                        type="text"
                                        placeholder="Start typing the name of your institute..."
                                        className="2aa5a868-b597-4401-80ac-1b1d03cb06c9"
                                        onChange={(e) => {
                                            setQuery(e.target.value);
                                            searchInstitution(e.target.value);
                                        }}
                                        onClick={() => { setQuery(''); setShowSearchBox(true); }}
                                        value={query}
                                    />
                                </p>
                            </div>
                    
                        
                    </div>
                    <div id="institute-searchbox" style={{ "display": (showSearchBox ? "block" : "none") }}>
                            {
                                institutes.map((ins: any) => (
                                    <p
                                        key={ins.name}
                                        onClick={(e: any) => handleInput(ins)}
                                        className={ins.institutionId === 'other' ? "institute-options afde582f-1be5-4568-a6d2-fb5a67d60524" : "institute-options"}
                                    >
                                        {ins.name}
                                    </p>
                                ))
                            }
                        </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <p>
                                <label className="00d09442-611e-48a4-ae2e-802f434cd1b4">Institution Name</label>
                                <input
                                    type='text'
                                    id="inst-name"
                                    placeholder="Institution's name"
                                    value={state.name}
                                    className="00d09442-611e-48a4-ae2e-802f434cd1b4"
                                    onChange={(e) => dispatch({
                                        type: 'field',
                                        field: 'name',
                                        value: e.target.value,
                                    })}
                                />
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p>
                                <label className='70f0e5b9-688c-438a-9c51-1d60b531aab5'>Institution Address Line 1</label>
                                <input
                                    type='text'
                                    id="inst-addr"
                                    placeholder="Institution Address Line 1"
                                    value={state.address1}
                                    className="70f0e5b9-688c-438a-9c51-1d60b531aab5"
                                    onChange={(e) => dispatch({
                                        type: 'field',
                                        field: 'address1',
                                        value: e.target.value,
                                    })}
                                />
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <p>
                                <label className='72aa28bd-f660-429f-9a86-8cd19e199adf'>Institution Address Line 2 (Optional)</label>
                                <input
                                    type='text'
                                    id="inst-addr2"
                                    placeholder="Institution Address Line 2 (Optional)"
                                    value={state.address2}
                                    className="72aa28bd-f660-429f-9a86-8cd19e199adf"
                                    onChange={(e) => dispatch({
                                        type: 'field',
                                        field: 'address2',
                                        value: e.target.value,
                                    })}
                                />
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p>
                                <label className="a70ac1ec-051c-4e7f-a8f5-6ad76ffa5ed5">Institution City</label>
                                <input
                                    type='text'
                                    id="inst-city"
                                    placeholder="Institution City"
                                    value={state.city}
                                    className="a70ac1ec-051c-4e7f-a8f5-6ad76ffa5ed5"
                                    onChange={(e) => dispatch({
                                        type: 'field',
                                        field: 'city',
                                        value: e.target.value,
                                    })}
                                />
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <p>
                                <label className="f2563706-07f8-4ae3-87e6-a812cc73419e">Institution State</label>
                                <input
                                    type='text'
                                    id="inst-state"
                                    placeholder="Institution State"
                                    value={state.state}
                                    className="f2563706-07f8-4ae3-87e6-a812cc73419e"
                                    onChange={(e) => dispatch({
                                        type: 'field',
                                        field: 'state',
                                        value: e.target.value,
                                    })}
                                />
                            </p>
                        </div>
                        <div className="col-sm-6">
                            <p>
                                <label className="d6c2cb84-1449-4cf0-bdb9-fd267b9d3453">Institution Country</label>
                                <select
                                    id='inst-country'
                                    value={props.institute.country.toLowerCase()}
                                    onChange={(e) => e ? dispatch({
                                        type: 'field',
                                        field: 'country',
                                        value: e.target.value,
                                    }) : null}
                                >
                                    <option value="" disabled className="d6c2cb84-1449-4cf0-bdb9-fd267b9d3453">Institution Country</option>
                                    {props.countries ? (Object.keys(props.countries).map((key: string) => {
                                        return <option key={key} value={key}>{props.countries![key]}</option>
                                    })) : <></>}
                                </select>
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <p>
                                <label className="a1bcc616-89aa-46ae-ad20-a7326112c864">Institution Zip Code</label>
                                <input
                                    type='text'
                                    id="inst-zip"
                                    placeholder="Institution Zipcode"
                                    value={state.zipCode}
                                    className="a1bcc616-89aa-46ae-ad20-a7326112c864"
                                    onChange={checkTrailingSpace(
                                        (e) => disp({
                                            type: 'field',
                                            field: 'zipCode',
                                            value: e.target.value,
                                        })
                                    )}
                                />
                            </p>
                        </div>
                    </div>
                </>
            </form>

            <div className="spacer"></div>
            <p className="buttons align-right row">
                <button
                    id="continue"
                    disabled={(!props.other && validationNeeded && JSON.stringify(props.institute) === JSON.stringify(init_Institution))}
                    className="button 394b58c5-ee63-4444-978a-c0373030b4f2" onClick={goNext} >Continue</button>
                <button className="gray button 041b8acf-fafc-450f-8111-d7d0c36bba6b" onClick={goBack}>Back</button>
            </p>
        </div >
    )
}

export default InstitutionInformation;
